export default {
  REQUEST_REQUEST_SERVICE(state) {
    state.status = "fetching";
  },
  SUCCESS_REQUEST_SERVICE(state, value) {
    state.status = "success";
  },
  FAILED_REQUEST_SERVICE(state) {
    state.status = "failed";
  },
};
